import React, { FC } from 'react'
import { Card, Row } from 'antd'
import { get } from 'lodash'
import { useDispatch } from 'react-redux'

// components
import LoginForm from './components/LoginForm'

// interfaces
import { ILoginForm } from '../../types/interfaces'

// actions
import { logInUser } from '../../reducers/authorization/authActions'

import backgroundImage from '../../assets/images/login-background.png'

const LoginPage: FC = () => {
	const dispatch = useDispatch()

	const handleSubmit = async (values: ILoginForm) => dispatch(logInUser(get(values, 'username'), get(values, 'password')))

	return (
		<div
			className={'object-fill bg-opacity-50 w-full h-full absolute top-0 left-0 bg-blend-color bg-blend-normal'}
			style={{
				background: `linear-gradient(0deg, rgba(236, 106, 0, 0.5) 50%, rgba(236, 106, 0, 0.5) 100%), url(${backgroundImage})`,
				backgroundSize: 'cover'
			}}
		>
			<Row align='middle' justify='center' className={'h-full'}>
				<Card style={{ width: '410px' }} className='rounded-md p-5 mt-4' bodyStyle={{ padding: '0' }}>
					<LoginForm onSubmit={handleSubmit} />
				</Card>
			</Row>
		</div>
	)
}

export default LoginPage
